import { Route } from '@angular/router';
import { ErrorComponent } from './error.component';
import { NotActivatedErrorComponent } from './not-activated/not-activated.component';
import { UnauthorizedErrorComponent } from './unauthorized/unauthorized.component';
import { UnregisteredErrorComponent } from './unregistered/unregistered.component';

export const errorRouting: Route = {
  path: 'error',
  children: [
    {
      path: 'unauthorized',
      component: UnauthorizedErrorComponent,
    },
    {
      path: 'not-activated',
      component: NotActivatedErrorComponent,
    },
    {
      path: 'unregistered',
      component: UnregisteredErrorComponent,
    },
    {
      path: ':errorid',
      component: ErrorComponent,
    },
    {
      path: '',
      pathMatch: 'full',
      component: ErrorComponent,
    },
  ],
};
